import { render, staticRenderFns } from "./DevBpbjWarehousingRecordForm.vue?vue&type=template&id=4e2e7ef4&scoped=true&"
import script from "./DevBpbjWarehousingRecordForm.vue?vue&type=script&lang=js&"
export * from "./DevBpbjWarehousingRecordForm.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjWarehousingRecordForm.vue?vue&type=style&index=0&id=4e2e7ef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e7ef4",
  null
  
)

export default component.exports